<proffeo-ui-divider />
<div class="animate-in fade-in-0 duration-200">
  <div class="flex flex-wrap gap-2 justify-between bg-proffeo-surface-muted p-1">
    <div class="flex flex-wrap gap-2">
      @if (isFileViewable(file())) {
        <proffeo-ui-button
          (clicked)="onPreview($event)"
          [iconSize]="ProffeoUiIconSize.SM"
          [tooltip]="'files.files-list-preview' | translate"
          fontIcon="visibility"
        ></proffeo-ui-button>
      }
      <proffeo-ui-button
        (clicked)="onDownload($event)"
        [iconSize]="ProffeoUiIconSize.SM"
        [tooltip]="'files.files-list-download' | translate"
        fontIcon="download"
      ></proffeo-ui-button>

      <!-- Set as Avatar -->
      @if (file()?.isImage() && isAvatar() === false && canSetAsAvatar()) {
        <proffeo-ui-button
          (clicked)="onSetAsAvatar($event)"
          [iconSize]="ProffeoUiIconSize.SM"
          [disabled]="isAvatar()"
          [tooltip]="'files.files-list-set-avatar' | translate"
          fontIcon="account_circle"
        ></proffeo-ui-button>
      }
    </div>

    <proffeo-ui-button
      (clicked)="onDelete($event)"
      [iconSize]="ProffeoUiIconSize.SM"
      [tooltip]="'files.files-list-delete' | translate"
      variant="accent"
      fontIcon="delete"
    ></proffeo-ui-button>
  </div>
</div>
